import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductionShiftService {
  constructor(
    private httpClient: HttpClient
  ) { }

  private POST_ENDPOINT: string = 'ProductionShift';
  private BASE_URL: string = `${environment.sistemaWebAdmin}`;
  private REQUEST_URL: string = `${this.BASE_URL}/${this.POST_ENDPOINT}`;

  getList(parameters: any): Observable<any> {
    let httpParams = new HttpParams({
      fromObject: parameters,
    });
    return this.httpClient.get<any>(`${this.REQUEST_URL}/pag`, { params: httpParams });
  }

  create(data: any): Observable<any>{
    return this.httpClient.post<any>(`${this.REQUEST_URL}`,data);
  }

  update(data: any): Observable<any>{
    return this.httpClient.put<any>(`${this.REQUEST_URL}`,data);
  }

  delete(id: number){
    return this.httpClient.delete<any>(`${this.REQUEST_URL}/` + id);
  }

  getReport(parameters: any): Observable<any> {
    let httpParams = new HttpParams({
      fromObject: parameters,
    });
    return this.httpClient.get<any>(`${this.REQUEST_URL}/report`, { params: httpParams });
  }

  getExportReport(parameters: any): Observable<any> {
    let httpParams = new HttpParams({
      fromObject: parameters,
    });
    return this.httpClient.get<any>(`${this.REQUEST_URL}/report-export`, { params: httpParams });
  }

  // Métodos para paradas programadas
  getStopScheduleList(idEnterprise: string): Observable<any> {
    return this.httpClient.get<any>(`${this.REQUEST_URL}/stop-schedule-list/enterprise/${idEnterprise}`);
  }

  getStopList(id: number): Observable<any> {
    return this.httpClient.get<any>(`${this.REQUEST_URL}/stop-list/id/${id}`);
  }

  createStop(data: any): Observable<any> {
    return this.httpClient.post<any>(`${this.REQUEST_URL}/stop`, data);
  }

  updateStop(data: any): Observable<any> {
    return this.httpClient.put<any>(`${this.REQUEST_URL}/stop`, data);
  }

  deleteStop(id: number): Observable<any> {
    return this.httpClient.delete<any>(`${this.REQUEST_URL}/stop/${id}`);
  }
}
